import mixin from '../../mixins/mixin';
import stripeAccountsService from '../../services/stripe_accounts';

export default {
  data() {
    return {
      stripe_name: '',
      stripeClientId: process.env.STRIPE_CLIENT_ID,
      smallLoading: false,
    };
  },
  props: {
    memberId: {
      required: false,
    },
    stripeAccount: {
      type: Object,
      required: true,
    },
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
  },
  mixins: [mixin],
  methods: {
    connectStripe() {
      if (this.stripeAccount.name !== '') {
        if (this.stripeAccount.stripe_public_key) {
          this.stripeAccount.stripe_public_key = this.stripeAccount.stripe_public_key.replace(/\s/g, '');
        }
        if (this.stripeAccount.stripe_secret_key) {
          this.stripeAccount.stripe_secret_key = this.stripeAccount.stripe_secret_key.replace(/\s/g, '');
        }
        if (this.stripeAccount.stripe_public_key && this.stripeAccount.stripe_secret_key) {
          this.storeStripeAccount();
        } else {
          this.redirectToStripeLoginPage();
        }
      }

      return false;
    },
    closeAddStripeAccount() {
      this.closeModal('#addStripeAccount');
    },
    updateStripeAccount(stripeAccount) {
      if (this.memberId) {
        stripeAccount.memberId = this.memberId;
      }
      this.smallLoading = true;
      stripeAccountsService.update(this, stripeAccount);
    },
    stripeAccountExists() {
      return (this.stripeAccount && this.stripeAccount.id);
    },
    storeStripeAccount() {
      if (this.memberId) {
        this.stripeAccount.memberId = this.memberId;
      }
      this.smallLoading = true;
      stripeAccountsService.store(this, this.stripeAccount);
    },
    redirectToStripeLoginPage() {
      localStorage.setItem('stripe_account_type', 'account');
      localStorage.setItem('settings_page', true);
      localStorage.setItem('stripe_name', this.stripeAccount.name);
      if (this.memberId) {
        localStorage.setItem('member_id', this.memberId);
      }
      location.href = `https://connect.stripe.com/login?redirect=%2Foauth%2Fauthorize%3Fscope%3Dread_write%26response_type%3Dcode%26client_id%3D${this.stripeClientId}&force_login=true`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/stripe-connect/connect.js